import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DashboardWidgetCard } from '@venecia/molecules';

@Component({
  selector: 'app-dashboard-latest-list-widget',
  imports: [CommonModule, DashboardWidgetCard, TranslateModule],
  templateUrl: './dashboard-latest-list-widget.html',
  styleUrl: './dashboard-latest-list-widget.scss',
})
export class DashboardLatestListWidget {
  @Input({ required: true }) titleKey = '';
  @Input({ required: true }) items: readonly DashboardLatestItem[] = [];
  @Input() emptyKey = 'pages.dashboard.latest.empty';
}

export interface DashboardLatestItem {
  readonly createdAt: string;
  readonly primary: string;
  readonly secondary: string;
}
